export default __webpack_public_path__ + "static/media/face-book.c150e095.svg";